import React, { useState } from 'react';
import classNames from 'classnames';
import { Row, Button, Col, Collapse } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { supportUrl } from 'Config/lang';

const RedeemFaqs = () => {
  const [faqOne, setFaqOne] = useState(false);
  const [faqTwo, setFaqTwo] = useState(false);
  const [faqThree, setFaqThree] = useState(false);
  const [faqFour, setFaqFour] = useState(false);

  return (
    <div className="voucher-faqs">
      <div className="voucher-faq">
        <Button
          block
          color="link"
          className="faq-link"
          onClick={() => { setFaqOne(true); }}
        >
          <Row>
            <Col xs={11}>
              <span>
                <FormattedMessage id="voucher-faqs.not-working" defaultMessage="My code is not working" />
              </span>
            </Col>
            <Col xs={1}>
              <FontAwesomeIcon icon={faChevronRight} className={classNames({ 'fa-rotate-90': faqOne }, 'arrow')} />
            </Col>
          </Row>
        </Button>
        <Collapse isOpen={faqOne} className="faq-content">
          <p>
            <FormattedMessage id="voucher-faqs.checks" defaultMessage="If your code hasn't worked, please check the following:" />
          </p>
          <ol className="faq-content-list">
            <li>
              <FormattedMessage id="voucher-faqs.code-matches" defaultMessage="Have you entered the code correctly? Check that the spelling and capitalisation of the code matches what you've entered." />
            </li>
            <li>
              <FormattedMessage id="voucher-faqs.tandcs" defaultMessage="Is the code still in date? Coupon/Voucher codes will only be valid for a certain period of time. Check the T and Cs to be sure. If your code has expired, you can view our active codes above." />
            </li>
            <li>
              <FormattedMessage id="voucher-faqs.code-valid" defaultMessage="Is the code valid on the items in your basket? Some codes will only work with certain items or it may have items excluded. When you apply your code, the cart will tell you if the code is invalid next to each individual item. Some codes will only apply when you have spent over a certain amount.Check the T and Cs to see any restrictions." />
            </li>
            <li>
              <FormattedMessage id="voucher-faqs.already-used" defaultMessage="Have you already used the code? Some codes can only be used on one transaction. Check the T and Cs to see any restrictions." />
            </li>
          </ol>
          <p>
            <FormattedMessage id="voucher-faqs.issues" defaultMessage="If you are still having issues, contact" />
            &nbsp;
            <a href={`${supportUrl()}`} target="_blank" rel="noopener noreferrer" className="brand-link">
              <FormattedMessage id="voucher-faqs.fan-support" defaultMessage="Fantical support." />
            </a>
          </p>
        </Collapse>
      </div>

      <div className="voucher-faq">
        <Button
          block
          color="link"
          className="faq-link"
          onClick={() => { setFaqTwo(true); }}
        >
          <Row>
            <Col xs={11}>
              <span>
                <FormattedMessage id="voucher-faqs.multiple-voucher" defaultMessage="Can I use multiple coupon or voucher codes?" />
              </span>
            </Col>
            <Col xs={1}>
              <FontAwesomeIcon icon={faChevronRight} className={classNames({ 'fa-rotate-90': faqTwo }, 'arrow')} />
            </Col>
          </Row>
        </Button>
        <Collapse isOpen={faqTwo} className="faq-content">
          <p>
            <FormattedMessage id="voucher-faqs.will-check" defaultMessage="No you can't apply more than one code to your cart. When you apply a code, it will check and remove any codes that are already applied on the cart." />
          </p>
        </Collapse>
      </div>
      <div className="voucher-faq">
        <Button
          block
          color="link"
          className="faq-link"
          onClick={() => { setFaqThree(true); }}
        >
          <Row>
            <Col xs={11}>
              <span>
                <FormattedMessage id="voucher-faqs.on-top-voucher" defaultMessage="Can I use coupon codes on top of other offers?" />
              </span>
            </Col>
            <Col xs={1}>
              <FontAwesomeIcon icon={faChevronRight} className={classNames({ 'fa-rotate-90': faqThree }, 'arrow')} />
            </Col>
          </Row>
        </Button>
        <Collapse isOpen={faqThree} className="faq-content">
          <p>
            <FormattedMessage id="voucher-faqs.majority-voucher" defaultMessage="The majority of our codes can be used on top of store discounts. Check the Tand Cs of each code for restrictions." />
          </p>
        </Collapse>
      </div>
      <div className="voucher-faq">
        <Button
          block
          color="link"
          className="faq-link"
          onClick={() => { setFaqFour(true); }}
        >
          <Row>
            <Col xs={11}>
              <span>
                <FormattedMessage id="voucher-faqs.valid" defaultMessage="What products are valid for my code?" />
              </span>
            </Col>
            <Col xs={1}>
              <FontAwesomeIcon icon={faChevronRight} className={classNames({ 'fa-rotate-90': faqFour }, 'arrow')} />
            </Col>
          </Row>
        </Button>
        <Collapse isOpen={faqFour} className="faq-content">
          <p>
            <FormattedMessage id="voucher-fas.restrictions" defaultMessage="Some coupon codes will have restrictions on what they can be used on. You might not be able to use the code on certain products like Star Deals or Bundles. Some codes will only apply when you have spent over a certain amount. Check the T and Cs of each code for restrictions." />
          </p>
        </Collapse>
      </div>
    </div>
  );
};

export default RedeemFaqs;
